export default __webpack_public_path__ + "static/media/Pradeep.4336221c.jpeg";